export const SAVE = 'stepPaymentDetails.SAVE';
export const VALUE_CHANGED = 'stepPaymentDetails.VALUE_CHANGED';
export const LOAD = 'stepPaymentDetails.VALUE_LOAD';
export const NEXT = 'stepPaymentDetails.NEXT';
export const RESET = 'stepPaymentDetails.RESET';
export const RESET_ADDRESS = 'stepPaymentDetails.RESET_ADDRESS';
export const RESET_REGISTER_GST_STATE = 'stepPaymentDetails.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'stepPaymentDetails.CLOSE_BSB_NOTICE';
export const SET_PAYMENT_TYPE_OPTIONS = 'stepPaymentDetails.SET_PAYMENT_TYPE_OPTIONS';

// Dynamic Payment Form
export const FNOL_GET_PAYMENT_CODE_TYPES = 'stepPaymentDetails.FNOL_GET_PAYMENT_CODE_TYPES';
export const FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS = 'stepPaymentDetails.FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS';
export const FNOL_GET_PAYMENT_FORM_FIELDS = 'stepPaymentDetails.FNOL_GET_PAYMENT_FORM_FIELDS';
export const FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS = 'stepPaymentDetails.FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS';
export const FNOL_SET_DYNAMIC_FIELD_VALUE = 'stepPaymentDetails.FNOL_SET_DYNAMIC_FIELD_VALUE';
export const FNOL_RESET_DYNAMIC_FORM = 'stepPaymentDetails.FNOL_RESET_DYNAMIC_FORM';
export const FNOL_SET_SELECTED_CODE_TYPE = 'stepPaymentDetails.FNOL_SET_SELECTED_CODE_TYPE';
export const FNOL_VALIDATE_CODE_FIELD = 'stepPaymentDetails.FNOL_VALIDATE_CODE_FIELD';
export const FNOL_SET_CODE_VERIFICATION_FAILED = 'stepPaymentDetails.FNOL_SET_CODE_VERIFICATION_FAILED';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/constants.js